"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaParamsRemanejados = exports.yupParamsRemanejados = exports.schemaParamsAvaliacaoPublicar = exports.yupParamsAvaliacaoPublicar = exports.schemaParamsAvaliacaoPaste = exports.yupParamsAvaliacaoPaste = exports.schemaAvaliac = exports.yupAvaliacao = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
const date_fns_1 = require("date-fns");
const enums_1 = require("../enums");
exports.yupAvaliacao = yup.object({
    descricao: yup
        .string()
        .required()
        .default('')
        .label('Descrição da avaliação')
        .min(1)
        .max(70, 'Máximo de 70 caracteres.'),
    valor: yup.number().required().min(1).max(100).default(100).label('Valor da avaliação'),
    calculo: yup.number().required().label('Cálculo da avaliação'),
    peso: yup.number().required().min(0.01).max(99.99).default(1).label('Peso da avaliação'),
    data: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(new Date(), 'yyyy-MM-dd')).label('Data da avaliação'),
    bimestre: yup.number().required().min(1).max(4).label('Etapa'),
    tipo: yup
        .mixed()
        .oneOf(Object.values(enums_1.ETipoAvaliacao))
        .required()
        .default(enums_1.ETipoAvaliacao['1 - Avaliação'])
        .label('Tipo de avaliação'),
    liberado: yup.bool().required().default(false).label('Avaliação liberada para o aluno'),
    idCurso: yup.number().positive().required().integer().label('Curso'),
    idSerie: yup.number().positive().required().integer().label('Série'),
    idTurma: yup.number().positive().required().integer().label('Turma'),
    idMateria: yup.number().positive().required().integer().label('Matéria'),
    idProfessor: yup.number().nullable().notRequired().default(null).label('Professor'),
    idUsuario: yup.number().nullable().notRequired().default(null).label('Usuário'),
    idMensagem: yup.number().nullable().notRequired().default(null).label('Mensagem'),
});
exports.schemaAvaliac = exports.yupAvaliacao.shape({});
exports.yupParamsAvaliacaoPaste = yup
    .object({
    idAvaliacoes: yup.array(yup.number()).required().default([]).label('Id das avaliações'),
})
    .concat(exports.yupAvaliacao.pick(['bimestre', 'idCurso', 'idSerie', 'idTurma', 'idMateria', 'idProfessor', 'idUsuario']));
exports.schemaParamsAvaliacaoPaste = exports.yupParamsAvaliacaoPaste.shape({});
exports.yupParamsAvaliacaoPublicar = yup
    .object({
    id: yup.number().integer().positive().required().label('Id da avaliação'),
})
    .concat(exports.yupAvaliacao.pick(['liberado']));
exports.schemaParamsAvaliacaoPublicar = exports.yupParamsAvaliacaoPublicar.shape({});
exports.yupParamsRemanejados = yup
    .object({
    anoLetivo: yup.string().required().label('Ano letivo'),
})
    .concat(exports.yupAvaliacao.pick(['bimestre', 'idTurma', 'idMateria']));
exports.schemaParamsRemanejados = exports.yupParamsRemanejados.shape({});
